import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { OperationInputModule } from '../operation-input/operation-input.module';
import { OperationInputAgFilterComponent } from './operation-input-ag-filter.component';

@NgModule({
  exports: [OperationInputAgFilterComponent],
  declarations: [OperationInputAgFilterComponent],
  imports: [CommonModule, OperationInputModule, ReactiveFormsModule],
})
export class OperationInputAgFilterModule {}
